import React, { Component } from "react";
import { Table } from "reactstrap";
import { Link, withRouter } from "react-router-dom";
import "./index.css";
import DetailsModal from "../DetailsModal";
import axios from "axios";
import downloadCsv from "download-csv";
import { cleanQueryParams } from "../../../_helpers/cleanurl";
import { reportPdfURL } from "../../../new/Utils/baseApi";

class TableNew extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDetailsModal: false,
      modalData: [],
      modalIndex: "",
      setModal: false,
      csvData: [],
      allChecked: false,
      isDownloading: false,
      downloadingId: null
    };
    this.toggleClass = this.toggleClass.bind(this);
  }

  clearHeaderCheckbox = () => {
    this.setState({ allChecked: false });
  };


  setAllChecked = (isAllChecked) => {
    this.setState({ allChecked: isAllChecked });
  };


  handleSelectAll = (event) => {
    const { data, handleSelectAll } = this.props;
    const allChecked = event.target.checked;
    handleSelectAll(allChecked);
    this.setState({ allChecked });
  };






  handleCheckboxChange = (event, columnData) => {
    const { selectedAssessments, handleCheckboxChange } = this.props;
    const checked = event.target.checked;

    handleCheckboxChange(checked, columnData);

    if (!checked) {
      this.setState({ allChecked: false });
    } else if (selectedAssessments.length + 1 === this.props.data.length) {
      this.setState({ allChecked: true });
    }
  };






  onClickSellCredit(table, id) {

    table.props.sellCreditsModal(!table.props.sellCreditsShowModal, id);
  }

  onClickRevokeCredit(table, instrument) {
    table.props.revokeCreditsModal(
      !table.props.revokeCreditsShowModal,
      instrument
    );
  }

  onClickRemoveSellerAdmin(table, sellerAdmin) {
    table.props.sellerAdminModal(
      !table.props.sellerAdminShowModal,
      sellerAdmin.email
    );
  }

  onClickprimaryAdmin(table, sellerAdmin) {
    table.props.modalOne !== undefined
      ? table.props.modalOne(
        !table.props.primaryAdminShowModal,
        sellerAdmin.email
      )
      : table.props.modalOne(!table.props.primaryAdminShowModal, sellerAdmin);
  }

  compareBy(key) {
    if (this.state.sortType == true) {
      return function (a, b) {
        if (a[key] < b[key]) return -1;
        if (a[key] > b[key]) return 1;
        return 0;
      };
    }

    if (this.state.sortType == false) {
      return function (a, b) {
        if (a[key] > b[key]) return -1;
        if (a[key] < b[key]) return 1;
        return 0;
      };
    }
  }

  sortBy(columnKey, type) {
    this.setState({ sortType: type });
    let arrayCopy = [...this.props.data];

    arrayCopy.sort(this.compareBy(columnKey));
    this.setState({ data: arrayCopy });
  }

  componentDidMount(prevProps) {
    let respondents = [...this.state.modalData];
    respondents.map((val) => {
      val[
        "respondent_completed_count_total_questions"
      ] = `${val.respondent_completed_count}/${val.user_assessment__assessment_number_count}`;
    });
    this.setState({
      respondents,
    });
  }

  toggleClass(res, index) {
    // Set modal index
    this.setState({ modalIndex: index });

    // Get URL parameters using URLSearchParams
    const params = new URLSearchParams(this.props.location.search);

    // Correctly extract organisation ID
    const organisationId = params.get('organisation');

    // Get batch_id
    const batch_id = params.get('batch') === "unalloted" ? 0 : params.get('batch');

    // Get seller ID from localStorage
    const sellerId = localStorage.getItem("Super_admin_sellerID");

    // Make API call with correct organisation ID
    axios
      .get(
        `/assessments/organisation/assessment/details/${sellerId}/${organisationId}/${res.id}/${batch_id}/`
      )
      .then((response) => {
        this.setState({ modalData: response.data.response.respondents }, () => {
          this.setState({ showDetailsModal: !this.state.showDetailsModal });
        });
      })
      .catch(error => {
        console.error('Error fetching assessment details:', error);
        // Handle error appropriately
      });
  }

  handleChildData = (data) => {
    this.setState({ showDetailsModal: data });
  };

  handleCSVDownload = (res) => {
    // Update the state to show loader
    this.setState({ isDownloading: true, downloadingId: res.id });

    const payload = {
      user_assessment: res.id,
      user: res.all.participant__id,
      relation_group_id: 10,
      relation_group_name: "360-Degree Feedback",
      screen_type: "assessment_summary",
      orientation_list: [2, 5, 1, 3, 4],
      responseType: "blob",
      isParticipant: true
    };

    axios
      .post("/assessments/pdf/data/new/", payload)
      .then((response) => {
        const decoder = JSON.parse(response.data.url);
        const url = reportPdfURL + decoder.endUrl;
        window.open(url, '_blank');
      })
      .catch((error) => {
        console.error('Error downloading PDF:', error);
      })
      .finally(() => {
        // Hide loader when API call completes (whether success or error)
        this.setState({ isDownloading: false, downloadingId: null });
      });
  };

  CSVDownload = (modalData) => {
    if (!modalData || modalData.length === 0) {
      console.error('No data available for download');
      return;
    }

    const columns = {
      EMAIL: "EMAIL",
      SHORT_NAME: "SHORT NAME",
      RELATION: "RELATION",
      PROGRESS: "PROGRESS",
      EXTREME_RESPONSE: "EXTREME RESPONSE"  // Added new column
    };

    try {
      const tableData = [];
      modalData.forEach((item) => {
        tableData.push({
          EMAIL: item.respondent__email || '-',
          "SHORT NAME": item.respondent__short_name || '-',
          RELATION: item.assessor_group__assessor_name || '-',
          PROGRESS: item.respondent_completed_count_total_questions || '-',
          "EXTREME RESPONSE": item.extreame_response === 0 ? 'Normal'
            : item.extreame_response === 1 ? 'Lowest Extreme'
              : 'Highest Extreme'
        });
      });

      downloadCsv(tableData, columns, `respondentDetails.csv`);
    } catch (error) {
      console.error('Error generating CSV:', error);
    }
  };









  render() {
    const table = this;
    const sellerState =
      this.props.sellerState !== undefined ? this.props.sellerState : "";
    const { columns, data, showSlNo, sortType, showCheckbox } = this.props;
    const props = this.props;

    const { allChecked } = this.state;



    localStorage.setItem("idStatus", table.state.idStatus);
    const userType = localStorage.getItem("usertype");
    const isAdmin =
      userType.includes("super_admin") ||
      userType.includes("seller_admin") ||
      userType.includes("organisation_admin");


    return (
      <Table bordered responsive className="animation-fade-in">
        <thead className="text-center">
          <tr>
            {showCheckbox && (
              <th className="text-muted quattrocentosans bold display-hover cursor-pointer">
                <input
                  type="checkbox"
                  checked={allChecked}
                  onChange={this.handleSelectAll}
                />
              </th>
            )}

            {showSlNo === "true" && (
              <th className="text-muted quattrocentosans bold display-hover cursor-pointer">
                #
              </th>
            )}
            {columns.map((column, index) => {
              return column.sort === true ? (
                <th
                  className="text-muted quattrocentosans bold display-hover cursor-pointer"
                  key={index}
                  onClick={() => {
                    this.props.sortBy(column.key);
                  }}
                >
                  {column.name !== "REMAINDER" && column.name}&nbsp;
                  {column.name === "REMAINDER" && (
                    <i className=" fas fa-bell"></i>
                  )}
                  &nbsp;
                  {sortType === false &&
                    column.sort === true &&
                    data.length > 1 && (
                      <i className="fas fa-sort-up custom-sort "></i>
                    )}
                  {sortType === true &&
                    column.sort === true &&
                    data.length > 1 && (
                      <i className="fas fa-sort-down custom-sort "></i>
                    )}
                  {column.sort === true && data.length > 1 && (
                    <i className="fas fa-sort custom-sort-display "></i>
                  )}
                </th>
              ) : (
                <th
                  className="text-muted quattrocentosans bold display-hover cursor-pointer"
                  key={index}
                >
                  {column.name !== "REMAINDER" && column.name}&nbsp;
                  {column.name === "REMAINDER" && (
                    <i className=" fas fa-bell"></i>
                  )}
                  &nbsp;
                </th>
              );
            })}
          </tr>
        </thead>

        <tbody className="text-center">
          {data.length > 0 &&
            data.map((columnData, i) => {
              const user_access__is_primary_admin =
                columnData.user_access__is_primary_admin !== undefined &&
                  columnData.user_access__is_primary_admin !== null
                  ? columnData.user_access__is_primary_admin
                  : false;
              return (
                <tr key={i}>
                  {showCheckbox && (
                    <td>
                      <input
                        type="checkbox"
                        checked={this.props.selectedAssessments.includes(columnData.id)}
                        onChange={(event) => this.handleCheckboxChange(event, columnData)}
                      />
                    </td>
                  )}


                  {showSlNo === "true" && <td>{i + 1}</td>}

                  {columns.map(function (column, index) {
                    return (
                      <td
                        key={index}
                        onClick={() => {
                          let currentStorage = [];
                          let counter = 0;
                          if (localStorage.getItem("columnData")) {
                            currentStorage = JSON.parse(
                              localStorage.getItem("columnData")
                            );
                            currentStorage.map((val) => {
                              if (val.id === columnData.id) {
                                counter++;
                                val = columnData;
                              }
                            });
                          }

                          if (counter === 0) {
                            currentStorage.push(columnData);
                          }
                          localStorage.setItem(
                            "columnData",
                            JSON.stringify(currentStorage)
                          );
                        }}
                      >
                        {column.link !== "" && column.type !== "logoText" && (
                          <Link
                            target={
                              column.target ? column.target.toString() : ""
                            }
                            className="text-dark text-underline"
                            to={{
                              pathname: column.link + columnData.id,
                              state: {
                                columnData: columnData,
                                index: i,
                                sellerData: columnData,
                                sellerState: sellerState,
                              },
                              linkId: columnData.id,
                            }}
                          >
                            {columnData[column.key]}
                          </Link>
                        )}



                        {column.type === "icon" && column.content === "add" && (
                          <i
                            onClick={() =>
                              table.props.sellCreditsModal(
                                !table.props.sellCreditsShowModal,
                                columnData.instrument__id
                              )
                            }
                            className="fa fa-plus-circle text-danger cursor-pointer"
                          ></i>
                        )}

                        {column.type === "icon" &&
                          column.content === "remove" &&
                          user_access__is_primary_admin === false && (
                            <i
                              onClick={() =>
                                table.props.revokeCreditsModal(
                                  !table.props.revokeCreditsShowModal,
                                  columnData
                                )
                              }
                              className="fa fa-minus-circle text-danger cursor-pointer"
                            ></i>
                          )}

                        {column.type === "logoText" &&
                          column.key === "instrument__instrument_name" &&
                          column.link !== "" &&
                          column.queryParams === undefined ? (
                          <Link
                            target={
                              column.target ? column.target.toString() : ""
                            }
                            className="text-dark text-underline"
                            to={{
                              pathname: column.link + columnData.id,
                              state: {
                                columnData: columnData,
                                index: i,
                                sellerData: columnData,
                                sellerState: sellerState,
                              },
                              linkId: columnData.id,
                            }}
                          >
                            <div>
                              <span>
                                <img
                                  src={
                                    localStorage.getItem("baseLink") +
                                    `/media/` +
                                    columnData.instrument__instrument_name[1]
                                  }
                                  style={{
                                    height: "1.5rem",
                                    width: "1.5rem",
                                    marginRight: "0.5rem",
                                  }}
                                />
                              </span>
                              <span>
                                {columnData.instrument__instrument_name[0]}
                              </span>
                            </div>
                          </Link>
                        ) : (
                          column.type === "logoText" &&
                          column.key === "instrument__instrument_name" &&
                          column.link !== "" &&
                          column.queryParams !== undefined && (
                            <Link
                              target={
                                column.target ? column.target.toString() : ""
                              }
                              className="text-dark text-underline"
                              to={{
                                pathname: `${column.link}${columnData.id}${cleanQueryParams(column.queryParams)}`,
                                state: {
                                  columnData: columnData,
                                  index: i,
                                  sellerData: columnData,
                                  sellerState: sellerState,
                                },
                                linkId: columnData.id,
                              }}
                            >
                              <div style={{ display: 'flex', alignItems: 'center' }}>
                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                  <img
                                    src={
                                      localStorage.getItem("baseLink") +
                                      `/media/` +
                                      columnData.instrument__instrument_name[1]
                                    }
                                    style={{
                                      height: "1.5rem",
                                      width: "1.5rem",
                                      marginRight: "0.5rem",
                                      verticalAlign: 'middle'  // This helps with image alignment
                                    }}
                                    alt=""  // Add alt for accessibility
                                  />
                                </span>
                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                  {columnData.instrument__instrument_name[0]}
                                </span>
                              </div>
                            </Link>
                          )
                        )}

                        {column.type === "logoText" &&
                          column.key === "instrument__instrument_name" &&
                          column.link === "" && (
                            <div>
                              <span>
                                <img
                                  src={
                                    localStorage.getItem("baseLink") +
                                    `/media/` +
                                    columnData.instrument__instrument_name[1]
                                  }
                                  style={{
                                    height: "1.5rem",
                                    width: "1.5rem",
                                    marginRight: "0.5rem",
                                  }}
                                />
                              </span>
                              <span>
                                {columnData.instrument__instrument_name[0]}
                              </span>
                            </div>
                          )}

                        {!columnData[column.childKey] &&
                          column.type === "deleteIcon" &&
                          column.content === "remove" && (
                            <i
                              onClick={() =>
                                table.props.sellerAdminModal(
                                  !table.props.sellerAdminShowModal,
                                  columnData.email
                                )
                              }
                              className="fa fa-minus-circle text-danger cursor-pointer"
                            ></i>
                          )}

                        {columnData[column.key] && column.type === "button" && (
                          <i className="fas fa-trophy text-green"></i>
                        )}

                        {!columnData[column.key] && column.type === "button" && (
                          <button
                            style={{ fontSize: "12px" }}
                            onClick={() =>
                              table.onClickprimaryAdmin(table, columnData)
                            }
                            className="btn btn-red btn-sm"
                          >
                            {column.content}
                          </button>
                        )}

                        {column.key !== "relation_list" &&
                          column.type !== "icon" &&
                          column.type !== "edit/deleteIcon" &&
                          column.type !== "remove/deleteicon" &&
                          column.link === "" &&
                          (columnData[column.key] === null ||
                            columnData[column.key] === undefined) &&
                          "-"}

                        {column.key === "EDIT/DELETE" &&
                          column.type === "edit/deletebutton" && (
                            <button
                              className="btn btn-red btn-sm"
                              onClick={() =>
                                props.onClickEditorDeleteButton(columnData)
                              }
                            >
                              {column.content}
                            </button>
                          )}

                        {column.key === "EDIT/DELETE" &&
                          column.type === "edit/deleteIcon" && (
                            <i
                              onClick={() =>
                                props.onClickEditorDeleteButton(columnData)
                              }
                              className="far fa-edit text-danger"
                            ></i>
                          )}

                        {column.key !== "relation_list" &&
                          column.link === "" &&
                          column.type !== "logoText" &&
                          columnData[column.key] !== null &&
                          column.key !== "respondent_count" &&
                          columnData[column.key]}

                        {column.key === "respondent_count" && (
                          <div
                            onClick={() => table.toggleClass(columnData, index)}
                            className="respondent_count"
                          >
                            {columnData[column.key]}
                          </div>
                        )}

                        {column.key === "is_RESPONDENTS_REPORT" && (
                          <i
                            onClick={() => table.handleCSVDownload(columnData)}
                            className={
                              columnData.is_submited === true
                                ? table.state.isDownloading && table.state.downloadingId === columnData.id  // Changed this to table.state
                                  ? "fas fa-spinner fa-spin"
                                  : "fa fa-download cursor-pointer downloadEnable"
                                : "fa fa-download downloadDisable"
                            }
                          ></i>
                        )}

                        {


                          column.key === "download_Status" &&
                          columnData.all.is_downloaded == null &&
                          "NO"
                        }
                        {column.key === "download_Status" &&
                          columnData.all.is_downloaded == true &&
                          "YES"}
                        {column.key === "download_Status" &&
                          columnData.all.is_downloaded == false &&
                          "NO"}



                        {column.key === "REMOVE/DELETE" &&
                          column.type === "remove/deleteicon" && (
                            <i
                              onClick={() =>
                                table.props.onClickRemoveorDeleteIcon(
                                  columnData
                                )
                              }
                              className="fa fa-minus-circle text-danger cursor-pointer"
                            ></i>
                          )}

                        {column.key === "relation_list" &&
                          column.link === "" &&
                          columnData[column.key].map((data, i) => {
                            if (columnData[column.key].length === i + 1) {
                              return data.accessor_group__assessor_name;
                            } else {
                              return data.accessor_group__assessor_name + ", ";
                            }
                          })}

                        {column.key === "default_enabled" &&
                          column.link === "" &&
                          columnData[column.key] === true && (
                            <i className="fas fa-check"></i>
                          )}

                        {column.key === "default_enabled" &&
                          column.link === "" &&
                          columnData[column.key] === false && (
                            <i className="fas fa-times"></i>
                          )}

                        {column.key === "is_submited" &&
                          columnData[column.key] === true && (
                            <i className="fas fa-check"></i>
                          )}

                        {column.key === "is_submited" &&
                          column.link === "" &&
                          columnData[column.key] === false && (
                            <i className="fas fa-times"></i>
                          )}

                        {column.key === "external_link" &&
                          columnData[column.key] !== null &&
                          column.queryParams === undefined ? (
                          <Link
                            target={
                              column.target ? column.target.toString() : ""
                            }
                            className="text-dark"
                            to={{
                              pathname: `${column.link}${table.props.defaultLink === undefined
                                ? columnData.id
                                : ""
                                }`,
                              state: {
                                columnData: columnData,
                                index: i,
                                sellerData: columnData,
                                sellerState: sellerState,
                              },
                              linkId: columnData.id,
                            }}
                          >
                            <i className="fas fa-external-link-alt text-green"></i>
                          </Link>
                        ) : (
                          column.key === "external_link" &&
                          columnData[column.key] !== null &&
                          column.queryParams !== undefined && (
                            <Link
                              target={
                                column.target ? column.target.toString() : ""
                              }
                              className="text-dark"
                              to={{
                                pathname: `${column.link}${table.props.defaultLink === undefined
                                  ? columnData.id
                                  : ""
                                  }${cleanQueryParams(column.queryParams)}`,
                                state: {
                                  columnData: columnData,
                                  index: i,
                                  sellerData: columnData,
                                  sellerState: sellerState,
                                },
                                linkId: columnData.id,
                              }}
                            >
                              <i className="fas fa-external-link-alt text-green"></i>
                            </Link>
                          )
                        )}

                        {column.key === "modalOpen" && (
                          <button
                            className="btn btn-red btn-sm"
                            onClick={() => table.props.openModal(columnData)}
                          >
                            DOWNLOAD
                          </button>
                        )}

                        {column.key === "groupReportLink" && (
                          <Link
                            onClick={() => {
                              props.groupReportData();
                            }}
                            to={{
                              pathname: `/app/dashBoard/viewReport/0/Download`,
                            }}
                            target="_blank"
                            className="btn btn-red btn-sm text-uppercase"

                          >
                            DOWNLOAD
                          </Link>
                        )}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          {data.length == 0 && (
            <tr>
              <td colSpan="10" className="text-center">
                No data to display
              </td>
            </tr>
          )}
        </tbody>
        {table.state.showDetailsModal && (
          <DetailsModal
            initialModalState={table.state.showDetailsModal}
            modalData={table.state.modalData}
            modalIndex={table.state.modalIndex}
            onChangeDataChange={this.handleChildData}
            ismodalDetails="true"
            onCSVDownload={this.CSVDownload}
          />
        )}
      </Table>
    );
  }
}

export default withRouter(React.forwardRef((props, ref) => <TableNew {...props} ref={ref} />));



// WEBPACK FOOTER //
// ./src/_components/common/TableNew/index.jsx